import React from 'react';
import { SERVICE_AGREEMENT_HTML } from './serviceAgreementContent';
import '../legalDoc.scss';

/**
 * Full Service Agreement, content ported verbatim from Laravel's
 * service-agreement.blade.php (opened in a new tab by the Consent Centre's
 * Platform Terms row and the registration consent links).
 */
export const ServiceAgreement: React.FC = () => {
  return (
    <div>
      {/* Slim branded bar — this page opens in a new tab from both logged-in and
          public contexts, so it stays standalone but matches the current app. */}
      <div className="bg-white border-b border-slate-200 py-2 px-6 flex items-center">
        <img src="/assets/images/logo.png" alt="Facilon" style={{ height: 40, objectFit: 'contain' }} />
      </div>
      <div className="public-page bg-slate-50 py-8 min-h-screen">
        <div className="container max-w-5xl mx-auto px-4 space-y-6">
          <div className="bg-[#052f55] p-6 rounded-xl shadow-sm">
            <h1 className="text-2xl font-bold m-0 flex items-center gap-2 text-white" style={{ color: '#ffffff' }}>
              <i className="bi bi-file-earmark-text-fill text-red-500"></i>
              <span>Service Agreement</span>
            </h1>
            <p className="text-slate-300 text-xs mt-1 mb-0">
              The agreement governing the services Facilon provides through its platform.
            </p>
          </div>
          <div
            className="bg-white border border-slate-200 rounded-xl p-6 shadow-xs legal-doc"
            dangerouslySetInnerHTML={{ __html: SERVICE_AGREEMENT_HTML }}
          />
        </div>
      </div>
    </div>
  );
};

export default ServiceAgreement;
